import { render } from "./ThankYouCampaigns.vue?vue&type=template&id=6d661f6f&scoped=true"
const script = {}

import "./ThankYouCampaigns.vue?vue&type=style&index=0&id=6d661f6f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d661f6f"]])

export default __exports__